import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { defaultPurchaseFeed, PurchaseNotification } from '../data/purchaseNotifications';
type PurchaseNotificationsProps = {
  /** Supply real order data (or an approved external feed) in production. */
  feed?: PurchaseNotification[];
  /** Time between notifications, in milliseconds. */
  intervalMs?: number;
  /** How long each notification stays visible, in milliseconds. */
  visibleMs?: number;
};
export function PurchaseNotifications({
  feed = defaultPurchaseFeed,
  intervalMs = 15000,
  visibleMs = 4500
}: PurchaseNotificationsProps) {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (feed.length === 0) return;
    let hideTimeout: number | undefined;
    const show = () => {
      setIsVisible(true);
      hideTimeout = window.setTimeout(() => {
        setIsVisible(false);
        setIndex(current => (current + 1) % feed.length);
      }, visibleMs);
    };
    const firstTimeout = window.setTimeout(show, 6000);
    const cycle = window.setInterval(show, intervalMs);
    return () => {
      window.clearTimeout(firstTimeout);
      window.clearTimeout(hideTimeout);
      window.clearInterval(cycle);
    };
  }, [feed.length, intervalMs, visibleMs]);
  if (feed.length === 0) return null;
  const current = feed[index];
  return <div className="pointer-events-none fixed inset-x-4 bottom-4 z-40 flex justify-center sm:inset-x-auto sm:bottom-6 sm:left-6 sm:justify-start" aria-live="polite" data-id="element-85" data-mp="1cie9yz4m564l">
      <AnimatePresence data-id="element-86" data-mp="12jf2vkzhxijp">
        {isVisible ? <motion.div key={current.id} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex w-full max-w-sm items-center gap-3 rounded-xl border border-navy-line bg-white/95 px-3.5 py-2.5 shadow-lift backdrop-blur sm:max-w-xs" data-id="element-87" data-mp="yjodnlpmbaha">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-teal-light text-teal-deep" data-id="element-88" data-mp="3pouglm8jqz9t">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-89" data-mp="3as3db1vr53ex" />
            </span>
            <div className="min-w-0" data-id="element-90" data-mp="3fqemrbi4xbwm">
              <p className="truncate text-[0.78rem] font-semibold text-navy" data-id="element-91" data-mp="3ftj1v3x51s22">
                {current.firstName} from {current.location}
              </p>
              <p className="truncate text-[0.7rem] text-navy-muted" data-id="element-92" data-mp="36rta1wzcgr3r">
                Purchased OT Clinical Toolkit™ • Digital access delivered
                instantly.
              </p>
            </div>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}